var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"flex flex-col gap-2 h-40 md:h-auto relative"},_vm._l((_vm.reviewsList),function(review){return _c('router-link',{key:review.id,staticClass:"cursor-pointer border p-1",attrs:{"to":{
      name: 'admin-reviews-detail',
      params: { id: ("" + (review.id)) },
      hash: '#details',
    },"active-class":"active-class-admin "}},[_c('span',{staticClass:"block"},[_vm._v(_vm._s(review.id)+".-"+_vm._s(review.title))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }